<template>
  <div class="layout-container">
    <Header></Header>
    <div class="menus">
      <div
        v-for="item in menus"
        :key="item.name"
        @mousemove="handleMove(item)"
        @click.stop.prevent="handleToggle(item)"
        @mouseleave="handleleave(item)"
        :class="['menu-item', active == item.name ? 'active' : '']"
      >
        <span class="parent-name"> {{ item.name }}</span>

        <div class="menus-children">
          <transition-group
            appear
            name="animate__animated animate__fade"
            enter-active-class="animate__fadeIn"
            leave-active-class="animate__fadeOut"
            tag="span"
          >
            <template v-if="item.children && active == item.name">
              <span
                v-for="it in item.children"
                :key="it.name"
                @click.stop.prevent="handleToggle(it)"
                class="menu-children-item"
                >{{ it.name }}</span
              >
            </template>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from '@/utils'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Layout',
  data() {
    return {
      active: '',
      menus: [
        { path: '/', name: '首页' },
        {
          path: '/onlineRegistrationV2',
          name: '智慧医疗',
          isLogin: true,
          children: [
            { isLogin: true, name: '预约挂号', path: '/onlineRegistrationV2' },
            { isLogin: true, name: '检验检查报告', path: '/report' },
            { isLogin: true, name: '药品查询', path: '/drugQuery' }
          ]
        },
        {
          path: '/medicalBooking',
          name: '健康管理',
          isLogin: true,
          children: [
            { isLogin: true, name: '体检预约', path: '/medicalBooking' },
            { isLogin: true, name: '体检报告', path: '/medicalReport' },
            { isLogin: true, name: '检后咨询', path: '/chat' }
          ]
        },
        { path: '/', name: '热门资讯', id: 101 },
        { path: '/', name: '体检资讯', id: 102 },
        {
          path: '/',
          name: '公共卫生服务',
          children: [
            {
              name: '疫情动态发布',
              herf: 'https://voice.baidu.com/act/newpneumonia/newpneumonia/?from=osari_aladin_banner'
            },
            {
              name: '核酸检测',
              herf: 'https://map.baidu.com/mobile/webapp/search/search/qt=con&wd=%E6%A0%B8%E9%85%B8%E6%A3%80%E6%B5%8B%E6%9C%BA%E6%9E%84&c=179&provider=pc-aladin&pn=0&device_ratio=1&da_src=shareurl&'
            },
            {
              name: '疫苗接种',
              herf: 'https://map.baidu.com/mobile/webapp/search/search/qt=s&wd=%E6%96%B0%E5%86%A0%E7%96%AB%E8%8B%97%E6%8E%A5%E7%A7%8D%E5%9C%B0%E5%9B%BE&c=179&searchFlag=bigBox&version=5&exptype=dep&src_from=webapp_all_bigbox&sug_forward=&src=1/vt='
            },
            {
              id: 103,
              name: '隔离管控'
            },
            {
              id: 104,
              name: '传染病管理'
            },
            {
              id: 105,
              name: '食品安全'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      layoutTitle: 'layout/lyaoutTitle'
    })
  },

  created() {},
  methods: {
    ...mapMutations({
      setLayoutTitle: 'layout/setLayoutTitle'
    }),
    handleToggle(item) {
      console.log(item)
      // 是否需要登录
      if (item.isLogin) {
        if (!sessionStorage.getItem('uuid')) {
          let uuId = uuid()
          window.open(
            `https://zjuam.zju.edu.cn/cas/oauth2.0/authorize?response_type=code&client_id=U2ZEp4RHRJTgzgy5Pq&redirect_uri=https://xyszyl.zju.edu.cn/medical/auth/codeRedirect&state=${uuId}_PC_index`,
            '_self'
          )
          return
        }
      }
      if (item.path) {
        this.$router.push({ path: item.path })
      }
      if (item.id) {
        this.$router.push({ path: '/articleList', query: { typeId: item.id } })
        this.setLayoutTitle(item.name)
      }
      if (item.herf) {
        window.open(item.herf, '_blank')
      }
    },
    // 鼠标经过
    handleMove(item) {
      this.active = item.name
    },
    handleleave(item) {
      this.active = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  span {
    display: inline-block;
  }
  .menus {
    height: 60px;
    padding: 0 320px;
    background: #022c64;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .menu-item {
      width: 120px;
      // padding: 0 60px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
      .parent-name {
        line-height: 60px;
        font-size: 18px;
      }
    }
    .active {
      // background: rgba(255, 255, 255, 1);
      background: #ffff;
      color: #022c64;
    }
  }
  .menus-children {
    position: absolute;
    z-index: 9999;
    cursor: pointer;
    .menu-children-item {
      display: block;
      width: 120px;
      font-size: 16px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #141f33;
      line-height: 42px;
      background: #ffff;
      border-bottom: 1px solid #eeee;
      &:hover {
        background: #022c64;
        color: #fff;
      }
    }
  }
}
</style>
